<div class="hb-card">
  <div class="hb-card-header">
    <h2 class="hb-card-tittel">{{ title() }}</h2>
    @if (lasterData) {
      <div>
        <span class="hb-spinner hb-spinner--tekst-justert" role="alert">
          <span class="hb-screenreader-only">Vennligst vent, laster datasett.</span>
        </span>
        <span class="hb-spinner-tekst hb-text--center">Vennligst vent, laster datasett...</span>
      </div>
    }

    <div class="hb-felt hb-text--right hb-avstand--ingen">
      <input id="{{ title() }}" class="hb-checkbox" type="checkbox" (change)="setFormatCsv()" [checked]="formatCsv" />
      <div class="hb-label">
        <label class="hb-label-tekst hb-text--xs" for="{{ title() }}">Last ned som CSV</label>
      </div>
    </div>
  </div>
  <div class="hb-card-body">
    @if (lastFeilet) {
      <div>
        <span class="hb-screenreader-only">Nedlasting feilet</span>
        <span class="hb-callout hb-callout--destructive">Nedlasting feilet, vennligst forsøk igjen eller ta kontakt med brukerservice</span>
      </div>
    }
    <table class="hb-table-no-lines">
      <tbody>
        @for (rad of rader(); track rad) {
          <tr>
            <td>{{ rad.radTittel }}</td>
            @for (link of rad.linker; track link) {
              <td>
                <a (click)="downloaddatasett(link.navn, link.objekt, link.tilstand, link.virkemiddel)">{{ link.navn }}</a>
              </td>
            }
          </tr>
        }
      </tbody>
    </table>
  </div>

  <footer class="hb-card-footer hb-card-utfallende--bunn">
    @if (dokumentasjon()) {
      <button hb-button variant="SUBTLE" iconId="hb-spreadsheet" (click)="downloadDocumentation()">Dokumentasjon</button>
    }

    <button
      hb-button
      variant="SUBTLE"
      [iconId]="visDatagrunnlagUtvidet ? 'remove' : 'book-open-text'"
      title="Vis datagrunnlag"
      (click)="visDatagrunnlagUtvidet = !visDatagrunnlagUtvidet"
    >
      Om datasettet
    </button>
    @if (visDatagrunnlagUtvidet) {
      <div>
        <div class="hb-p--lg" id="info+id">
          <span class="hb-text--xs">{{ omDataGrunnlaget() }}</span>
        </div>
      </div>
    }
  </footer>
</div>
